
import { Component, Prop, Vue } from 'vue-property-decorator'

import MachModel from '../models/Mach'

import isMobile from '@/widget/utils/isMobile'
import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class Mach extends Vue {
  @Prop({ required: true }) readonly mach!: MachModel

  showOpenAppButton = isMobile()

  get isInstructionsVisible(): boolean {
    return this.mach.instructions.filter(Boolean).length > 0
  }

  private payInApp() {
    window.open(this.mach.appLink, '_blank')
  }
}
